"use client";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Actionable from "../Actionable/index.js";
import Text from "../Text/index.js";
import SelectStartContent from "./SelectStartContent.js";
import s from "./Select.module.css";
import SelectEndContent from "./SelectEndContent.js";
const SelectTrigger = (props) => {
    const { children, disabled, onClick, onFocus, onBlur, inputAttributes, startSlot, icon, size, placeholder, value, name, id, } = props;
    return (_jsxs(_Fragment, { children: [_jsxs(Actionable, { className: s.input, disabled: disabled, disableFocusRing: true, onClick: onClick, attributes: {
                    onFocus: onFocus || inputAttributes?.onFocus,
                    onBlur: onBlur || inputAttributes?.onBlur,
                    ...inputAttributes,
                }, children: [_jsx(SelectStartContent, { startSlot: startSlot, icon: icon, size: size }), children ? _jsx(Text, { maxLines: 1, children: children }) : null, placeholder && !children ? _jsx(Text, { color: "disabled", children: placeholder }) : null, _jsx(SelectEndContent, { disabled: disabled, size: size })] }), _jsx("input", { type: "hidden", value: typeof value === "string" ? value : JSON.stringify(value), name: name, id: id })] }));
};
export default SelectTrigger;
